var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.item.id))]),_c('td',[_vm._v(_vm._s(_vm.item.time_start))]),_c('td',[_vm._v(_vm._s(_vm.item.count_player))]),_vm._l((_vm.sectorsValue),function(item,index){return _c('td',{key:index},[_vm._v(_vm._s(item))])}),_c('td',[_vm._v(_vm._s(_vm.item.win_sector.value.value))]),_c('td',[_vm._v(_vm._s(_vm.item.total))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }